import React, { useState } from 'react'
import { Popover, Button, Switch } from 'antd'
import { Zap, Database } from 'lucide-react'
import styled from 'styled-components'
import { useSuperpowers } from '../../../../../context/superpowers'
import { RagInspectorModal } from '../../../Modals/RagInspectorModal'
import { StyledButtonWrapper } from '../../styles/MindMapHeaderStyles'
import { TYPOGRAPHY, FONT_WEIGHT } from '../../../../../styles/theme'

// --- Styled components ---

const Container = styled.div`
  width: 240px;
  padding: 6px;
  background: var(--color-bg-elevated);
`

const Header = styled.div`
  padding: 8px 12px;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 4px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-primary);
  border-radius: 6px;
`

const ClickableRow = styled(Row)`
  cursor: pointer;

  &:hover {
    background: var(--color-bg-hover);
  }
`

// --- Component ---

export const SuperpowersMenu: React.FC = () => {
  const { disablePortraitGeneration, setDisablePortraitGeneration } = useSuperpowers()
  const [menuOpen, setMenuOpen] = useState(false)
  const [ragInspectorOpen, setRagInspectorOpen] = useState(false)

  return (
    <>
      <Popover
        content={
          <Container>
            <Header>Superpowers</Header>
            <Row>
              Disable portrait generation
              <Switch
                size="small"
                checked={disablePortraitGeneration}
                onChange={setDisablePortraitGeneration}
              />
            </Row>
            <ClickableRow
              onClick={() => {
                setRagInspectorOpen(true)
                setMenuOpen(false)
              }}
            >
              RAG Inspector
              <Database size={14} />
            </ClickableRow>
          </Container>
        }
        trigger="click"
        placement="bottomRight"
        open={menuOpen}
        onOpenChange={setMenuOpen}
        styles={{ body: { padding: 0 } }}
      >
        <StyledButtonWrapper>
          <Button
            type={disablePortraitGeneration ? 'primary' : 'default'}
            icon={<Zap size={16} />}
          />
        </StyledButtonWrapper>
      </Popover>

      <RagInspectorModal isVisible={ragInspectorOpen} onClose={() => setRagInspectorOpen(false)} />
    </>
  )
}
